export const INIT_MATOMO = 'INIT_MATOMO';
export const PUSH_EVENT = 'PUSH_EVENT';
export const PREPARE_EVENT = 'PREPARE_EVENT';
export const CLEAR_EVENTS = 'CLEAR_EVENTS';
/** @namespace Bodymod/Matomo/Store/Matomo/Action/initMatomo */
export const initMatomo = (matomo) => ({
    type: INIT_MATOMO,
    matomo
});

/** @namespace Bodymod/Matomo/Store/Matomo/Action/pushEvent */
export const pushEvent = (event, data) => ({
    type: PUSH_EVENT,
    event,
    data
});

/** @namespace Bodymod/Matomo/Store/Matomo/Action/prepareEvent */
export const prepareEvent = () => ({
    type: PREPARE_EVENT
});

/** @namespace Bodymod/Matomo/Store/Matomo/Action/clearEvents */
export const clearEvents = (eventsToClear) => ({
    type: CLEAR_EVENTS,
    eventsToClear
});
